import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { signOut } from 'firebase/auth';
import { auth, db } from '../utils/FirebaseConfig';
import '../styles/Status.css'; // ✅ Import the new CSS file
import { FaSignOutAlt } from 'react-icons/fa'; // Import the logout icon
import { Stepper, Step, StepLabel } from '@mui/material';
import InfoBank from "../components/InfoBank";



const Status = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState('');
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const currentYear = new Date().getFullYear();
    const packageAmount = Number(userData?.packageAmount || 3600);
    const shippingFee = Number(userData?.shippingFee || 0);
    const totalAmount = Number(userData?.totalAmount || packageAmount + shippingFee);


    useEffect(() => {
        const storedPending = localStorage.getItem('pendingRegistration');
        if (storedPending) {
            try {
                setUserData(JSON.parse(storedPending));
                return;
            } catch (error) {
                console.warn("Rekod pendaftaran tempatan tidak dapat dibaca:", error);
                localStorage.removeItem('pendingRegistration');
            }
        }

        const storedEmail = localStorage.getItem('submittedEmail');
        console.log("📧 Fetching data for:", storedEmail); // ✅ Log the email being used
        if (storedEmail) {
            fetchSubmitterData(storedEmail);
        }
    }, []);

    // const fetchSubmitterData = async (emailToCheck) => {
    //     console.log("🔍 Querying Firestore for:", emailToCheck);
    //     const submitterQuery = query(
    //         collection(db, 'submitters'),
    //         where('emailMasjid', '==', emailToCheck)
    //     );
    //     const querySnapshot = await getDocs(submitterQuery);

    //     if (!querySnapshot.empty) {
    //         console.log("✅ Firestore document found!");
    //         querySnapshot.forEach((doc) => {
    //             console.log("📄 Firestore Data:", doc.data()); // ✅ Log Firestore data
    //             setUserData({ id: doc.id, ...doc.data() });
    //         });
    //     } else {
    //         console.warn("❌ No matching document in Firestore for:", emailToCheck);
    //         setUserData(null);
    //     }
    // };

    // ✅ Gantikan fungsi lama ini dengan versi auto-fallback
    const fetchSubmitterData = async (emailToCheck) => {
        if (!emailToCheck) return;

        const cleanEmail = emailToCheck.trim().toLowerCase();
        console.log("🔍 Mula cari data untuk:", cleanEmail);

        try {
            // 🔹 1. Cari dalam submitters
            const submitterQuery = query(
                collection(db, "submitters"),
                where("emailMasjid", "==", cleanEmail)
            );
            const submitterSnap = await getDocs(submitterQuery);

            if (!submitterSnap.empty) {
                const docSnap = submitterSnap.docs[0];
                console.log("✅ Jumpa dalam submitters:", docSnap.id);
                setUserData({
                    id: docSnap.id,
                    ...docSnap.data(),
                    source: "submitters",
                });
                return;
            }

            // 🔹 2. Kalau tak jumpa, cuba cari dalam users
            console.log("🔍 Cuba cari dalam users pula...");
            const userQuery = query(
                collection(db, "users"),
                where("emailMasjid", "==", cleanEmail)
            );
            const userSnap = await getDocs(userQuery);

            if (!userSnap.empty) {
                const docSnap = userSnap.docs[0];
                console.log("✅ Jumpa dalam users:", docSnap.id);
                setUserData({
                    id: docSnap.id,
                    ...docSnap.data(),
                    source: "users",
                });
                return;
            }

            // ❌ Tak jumpa di mana-mana
            console.warn("❌ Tak jumpa dalam submitters atau users:", cleanEmail);
            setUserData(null);
        } catch (err) {
            console.error("🔥 Ralat Firestore:", err);
            setUserData(null);
        }
    };

    // ✅ Gantikan handleUploadPaymentSlip juga — supaya update ikut source betul
    const handleUploadPaymentSlip = async () => {
        if (!file || !userData) {
            console.error("❌ File atau userData tiada!");
            return;
        }

        setUploading(true);
        const storage = getStorage();
        const storageRef = ref(storage, `paymentSlips/${userData.emailMasjid}/${file.name}`);

        try {
            console.log("📤 Muat naik ke:", storageRef.fullPath);
            await uploadBytes(storageRef, file);
            const downloadURL = await getDownloadURL(storageRef);
            console.log("✅ Fail siap dimuat naik:", downloadURL);

            // Tentukan collection mana nak update
            const targetCollection = userData.source === "users" ? "users" : "submitters";
            console.log(`📌 Kemas kini Firestore pada koleksi [${targetCollection}] dokumen:`, userData.id);

            const targetDoc = doc(db, targetCollection, userData.id);
            await updateDoc(targetDoc, {
                paymentSlipUrl: downloadURL,
                status: "review",
            });

            console.log("✅ Firestore berjaya dikemas kini!");
            setUserData((prev) => ({
                ...prev,
                paymentSlipUrl: downloadURL,
                status: "review",
            }));
        } catch (error) {
            console.error("❌ Gagal kemas kini Firestore:", error);
            setError("Gagal muat naik. Cuba lagi sebentar.");
        } finally {
            setUploading(false);
        }
    };


    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            console.log("📂 File Selected:", selectedFile.name);
        }
    };



    // ✅ Logout Function
    const handleLogout = async () => {
        try {
            console.log("🔴 Logging out user...");
            await signOut(auth); // Firebase Auth Logout
            localStorage.removeItem('submittedEmail'); // Clear stored email
            navigate('/'); // Redirect to login page
        } catch (error) {
            console.error("❌ Logout error:", error);
        }
    };

    return (
        <div className='page-container'>

            <div className="loginHeader">
                <div className='logo-group-login'>
                    <img src="/images/e-icon.png" className="logo-login" alt="Etikaf" />
                    <span className="badge-login">Status</span>
                </div>
            </div>

            <div className="status-container">

                <p className='status-title'><strong>{userData?.namaMasjid || "Loading..."}</strong></p>

                {error && <p className="error-message">{error}</p>}

                {userData && (
                    <div className='status-inside'>
                        {/* Progress Stepper */}
                        <Stepper activeStep={
                            userData?.status === "register" ? 0 :
                                userData?.status === "pending_payment" ? 1 :
                                userData?.status === "payment" ? 1 :
                                    userData?.status === "review" ? 2 :
                                        userData?.status === "active" ? 3 : 0
                        } alternativeLabel>
                            <Step>
                                <StepLabel>Daftar</StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>Bayar</StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>Semakan</StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>Aktif</StepLabel>
                            </Step>
                        </Stepper>


                        <div>
                            {userData.status === "pending_payment" && (
                                <div className="pending-package-card">
                                    <p><strong>Pendaftaran anda telah disimpan</strong></p>
                                    <h2>RM{totalAmount.toLocaleString("ms-MY")}</h2>
                                    <p>Pakej lengkap Etikaf merangkumi peranti ETV dan langganan Sistem Admin selama 12 bulan.</p>
                                    <ul>
                                        <li>Peranti Etikaf TV — RM3,000</li>
                                        <li>Langganan Sistem Etikaf — RM600</li>
                                        <li>Aplikasi Etikaf untuk jemaah — Percuma</li>
                                        <li>Penghantaran — {shippingFee ? `RM${shippingFee}` : "Mengikut bil asal"}</li>
                                    </ul>
                                    {userData.billUrl ? (
                                        <button className="loginButton" onClick={() => { window.location.href = userData.billUrl; }}>
                                            Sambung bayaran RM{totalAmount.toLocaleString("ms-MY")}
                                        </button>
                                    ) : (
                                        <p className="error-message">Pautan bayaran belum tersedia. Sila hubungi pihak Etikaf.</p>
                                    )}
                                </div>
                            )}
                            {userData.status === "review" && (
                                <>
                                    <p className='status-message'>Bayaran sedang disemak</p>
                                    <br />
                                    <p className='status-message'>Terima Kasih</p>
                                </>
                            )}
                            {userData.status === "payment" && (
                                <>
                                    <br />
                                    <p><strong>Sistem Etikaf</strong></p>

                                    <h2><strong>RM600 / tahun</strong></h2>
                                    <br />

                                    <p>
                                        Bayaran ini digunakan untuk menampung kos <strong>server, penyelenggaraan, dan peningkatan sistem</strong>,
                                        memastikan Sistem Etikaf dapat berfungsi dengan lancar sepanjang tahun.
                                    </p>
                                    <br />

                                    <div className="feature-list">
                                        <div className="feature-item"><strong>Akses penuh ke Sistem Etikaf</strong> untuk pengurusan masjid yang lebih efisien.</div>
                                        <div className="feature-item"><strong>Server berprestasi tinggi</strong> memastikan kelancaran akses tanpa gangguan.</div>
                                        <div className="feature-item"><strong>Penyelenggaraan berkala & sokongan teknikal</strong> untuk memastikan sistem sentiasa dikemas kini dan selamat.</div>
                                        <div className="feature-item"><strong>Peningkatan ciri-ciri baru</strong> untuk kemudahan pengurusan komuniti masjid.</div>
                                        <div className="feature-item"><strong>Aplikasi mudah alih (Android & iOS)</strong> untuk semua jemaah, memudahkan akses di mana sahaja.</div>
                                    </div>

                                    <br />

                                    <p>
                                        Dengan langganan ini, anda turut membantu pembangunan sistem ke arah yang lebih baik
                                        untuk manfaat semua pengguna.
                                    </p>
                                    <InfoBank />

                                </>
                            )}
                        </div>
                        <div>
                            {userData.status === "payment" && (
                                <div className="payment-section">
                                    <div className="payment-box">
                                        <p className="payment-title"><strong>Sila muat naik resit pembayaran untuk mengaktifkan akaun</strong></p>

                                        <div className="file-upload-container">
                                            <label htmlFor="fileUpload" className="file-upload-label">
                                                📂 Pilih Fail
                                            </label>
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                className="file-upload"
                                                onChange={handleFileChange}
                                            />
                                        </div>

                                        {/* Show Selected File Name */}
                                        {file && (
                                            <p className="file-name">
                                                <strong>{file.name}</strong>
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div>
                            {userData.status === "review" && (
                                <p>Anda akan dapat akses ke dalam sistem tidak lama lagi</p>
                            )}
                            {userData.status === "payment" && (
                                <>
                                    <button className="loginButton" onClick={handleUploadPaymentSlip} disabled={uploading}>
                                        {uploading ? "Uploading..." : "Hantar"}
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>

            <button className="logout-button" onClick={handleLogout}>
                <FaSignOutAlt size={20} /> {/* Logout icon */}
            </button>
            <div className="footer-text">
                &copy; 2017-{currentYear} Etikaf Ent.
            </div>

        </div>
    );
};

export default Status;
